module.exports = __webpack_public_path__ + "img/ForbesIndia.6abd1b2f.jpg";